import React, { useState } from "react";
import {
    AreaChart,
    Area,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts";

export default function SalesEarningChart() {
    const [period, setPeriod] = useState("Month");

    // Dummy data
    const dataSets = {
        Day: Array.from({ length: 7 }, (_, i) => ({
            name: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"][i],
            earning: Math.floor(Math.random() * 100000 + 50000),
        })),
        Week: Array.from({ length: 4 }, (_, i) => ({
            name: `Week ${i + 1}`,
            earning: Math.floor(Math.random() * 400000 + 100000),
        })),
        Month: [
            { name: "Jan", earning: 120000 },
            { name: "Feb", earning: 140000 },
            { name: "Mar", earning: 130000 },
            { name: "Apr", earning: 170000 },
            { name: "May", earning: 190000 },
            { name: "Jun", earning: 250000 },
            { name: "Jul", earning: 450000 },
            { name: "Aug", earning: 570000 },
            { name: "Sep", earning: 400000 },
            { name: "Oct", earning: 300000 },
            { name: "Nov", earning: 380000 },
            { name: "Dec", earning: 350000 },
        ],
        Year: [
            { name: "2020", earning: 1200000 },
            { name: "2021", earning: 1800000 },
            { name: "2022", earning: 1500000 },
            { name: "2023", earning: 2000000 },
            { name: "2024", earning: 1700000 },
        ],
    };

    const data = dataSets[period];
    const totalEarning = 6345; 

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            return (
                <div
                    className="bg-white border rounded-3 px-2 py-1 shadow-sm"
                    style={{ fontSize: "0.8rem", fontWeight: "500" }}
                >
                    {`${(payload[0].value / 1000).toFixed(0)}k`}
                </div>
            );
        }
        return null;
    };

    const tabContainerStyle = {
        display: "flex",
        alignItems: "center",
        background: "#f8f8ff",
        padding: "6px",
        borderRadius: "8px",
        gap: "4px",
    };

    const pillStyle = (active) => ({
        padding: "6px 12px",
        borderRadius: "8px",
        cursor: "pointer",
        background: active ? "#0064CF" : "transparent",
        color: active ? "#fff" : "#9291A5",
        border: "none",
        fontSize: "14px",
        fontWeight: 500,
        transition: "all 0.2s ease",
    });

    return (
        <div className="w-100 p-4">
            <div className="w-100 rounded-2 border p-3" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                {/* Header */}
       <div className="w-100 d-flex justify-content-between align-items-center mb-3">
                    <div>
                        <h6 className="text-muted mb-1 fs-5">Total Earning</h6>
                        <h4 className="fw-bold fs-2">{totalEarning.toLocaleString()}</h4>
                    </div>

                    {/* Period Selector */}
                    <div style={tabContainerStyle}>
                        {["Day", "Week", "Month", "Year"].map((label) => (
                            <button
                                key={label}
                                style={pillStyle(period === label)}
                                onClick={() => setPeriod(label)}
                            >
                                {label}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Chart */}
                <ResponsiveContainer width="100%" height={300}>
                    <AreaChart
                        data={data}
                        margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                    >
                        <defs>
                            <linearGradient id="colorEarning" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="5%" stopColor="#4F46E5" stopOpacity={0.3} />
                                <stop offset="95%" stopColor="#4F46E5" stopOpacity={0} />
                            </linearGradient>
                        </defs>
                        <CartesianGrid
                            strokeDasharray="3 3"
                            vertical={false}
                            stroke="#e5e7eb"
                        />
                        <XAxis dataKey="name" tick={{ fontSize: 12 }} />
                        <YAxis
                            tickFormatter={(val) =>
                                val >= 1000 ? `${(val / 1000).toFixed(0)}k` : val
                            }
                            tick={{ fontSize: 12 }}
                        />
                        <Tooltip content={<CustomTooltip />} cursor={{ strokeDasharray: "3 3" }} />
                        <Area
                            type="monotone"
                            dataKey="earning"
                            stroke="#4338CA"
                            strokeWidth={3}
                            fillOpacity={1}
                            fill="url(#colorEarning)"
                            dot={false}
                            activeDot={{ r: 6, fill: "#4338CA" }}
                        />
                    </AreaChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}
